import React, { FunctionComponent, useLayoutEffect, useMemo, useRef } from "react";

import { Dropdown, DropdownCaptionItem, DropdownItem } from "@multiweb/dropdown";
import { ButtonBackgroundColor, IconButton, IconColor, IconSize } from "@multiweb/reactComponents";
import { doNothing } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { IWorkflowMenuItem } from "@multiweb/types/multiweb";

export type WorkflowButtonComponentProps = {
    /** Nápověda po najetí myši */
    title: string;
    /** Funkce, jejíž volání zajistí načtení akcí */
    loadActions: () => void;
    /** Workflow akce a jejich vlastnosti */
    workflowActions?: IWorkflowMenuItem[];
    /** Příznak, zda jsou workflow akce načítány */
    isLoading: boolean;
    /** Funkce, jejiž volání zajistí provedení akce */
    executeAction: (workflowActionId: string) => void;
    /** Pošle info o své velikosti */
    onSizeCallback?: (id: string, size: number) => void;
    /** Určuje zda je zakázán */
    disabled?: boolean;
    /** Šířka dropdownu */
    dropdownWidth?: number;
    /** Maximální šířka dropdownu */
    dropdownMaxWidth?: number;
};

export const WorkflowButtonComponent: FunctionComponent<WorkflowButtonComponentProps> = ({
    title,
    loadActions,
    workflowActions,
    isLoading,
    executeAction,
    onSizeCallback = doNothing,
    disabled,
    dropdownWidth = 200,
    dropdownMaxWidth = 300,
}) => {
    const ref = useRef(null);

    useLayoutEffect(() => {
        if (ref.current && onSizeCallback) {
            onSizeCallback("workflow", (ref.current as unknown as HTMLDivElement).clientWidth);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const items = useMemo(() => {
        if (workflowActions && workflowActions.length > 0) {
            const items = workflowActions?.map(action =>
                <DropdownItem
                    key={action.ID}
                    clickAction={{
                        title: action.Codename,
                        text: action.ItemName,
                        onClick: (event) => {
                            executeAction(action.ID);
                            event.stopPropagation(); //TODO - 38304 odstranit po vyřešení bugu s klikatelným row
                        },
                    }} />,
            );

            items.unshift(<DropdownCaptionItem key="GUI-348255" locKey={"GUI-348255"} />); //WorkFlow
            return items;
        }

        return [<DropdownCaptionItem key="GUI-777707" locKey={"GUI-777707"} />]; //Žádné akce
    }, [workflowActions, executeAction]);

    return (
        <div ref={ref}>
            <Dropdown width={dropdownWidth} maxWidth={dropdownMaxWidth} isLoading={isLoading} triggerRenderer={(triggerButtonProps) => (
                <IconButton
                    iconCode={IconCode.recordActions}
                    color={IconColor.colorPrimary}
                    size={IconSize.small}
                    backgroundColor={ButtonBackgroundColor.transparent}
                    {...triggerButtonProps}
                    {...{ disabled, title }}
                    onClick={(event) => {
                        loadActions();
                        triggerButtonProps.onClick(event);
                    }}
                />
            )}>
                {items}
            </Dropdown>
        </div>
    );
};
